export const RECEIVE_TRADE_ACCOUNT_LIST = 'receive_trade_account_list'

export const RECEIVE_TRADE_ACCOUNT_ORDERID = 'receive_trade_account_orderid'

export const RECEIVE_TRADE_ACCOUNT_RECORDS = 'receive_trade_account_records'

export const RECEIVE_USERINFO = 'receive_userinfo'

export const RECEIVE_ACCOUNTINFO = 'receive_accountinfo'

export const RECEIVE_REJECT_RECORDS = 'receive_reject_records'

export const RECEIVE_LANGUAGE = 'receive_language'

export const RECEIVE_ACCOUNT_BALANCE = 'receive_account_balance'
